<div class="list-filter-single d-flex align-content-center" [ngClass]="{'list-filter-single--chosen':isValue}">
  <div class="list-filter-single__label">
    <svg-icon [src]="iconUrl" [svgStyle]="{width: '16px', height: '16px'}" [title]="name"></svg-icon>
    <div class="list-filter-single__label__text">
      {{ name }}
    </div>
  </div>
  <ng-container *ngTemplateOutlet="template"></ng-container>
</div>
